// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/BannedUsersPanel.css */
/* Banned Users Panel styling */

.banned-users-panel {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #1e1b4b 0%, #312e81 100%);
  color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  overflow-y: auto;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid rgba(139, 92, 246, 0.3);
  background: rgba(0, 0, 0, 0.2);
}

.panel-header h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}

.refresh-button {
  padding: 8px 16px;
  background: rgba(139, 92, 246, 0.2);
  border: 1px solid #8b5cf6;
  border-radius: 6px;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.refresh-button:hover {
  background: rgba(139, 92, 246, 0.3);
  transform: translateY(-1px);
}

.panel-content {
  padding: 30px;
  max-width: 1400px;
  margin: 0 auto;
}

/* Ban Section */
.ban-section {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(139, 92, 246, 0.3);
  border-radius: 8px;
  padding: 25px;
  margin-bottom: 30px;
}

.ban-section h2 {
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 600;
  color: #8b5cf6;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
}

.form-group select,
.form-group input {
  width: 100%;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(139, 92, 246, 0.3);
  border-radius: 6px;
  color: #ffffff;
  font-size: 14px;
  outline: none;
  transition: all 0.2s;
}

.form-group select:focus,
.form-group input:focus {
  border-color: #8b5cf6;
  background: rgba(255, 255, 255, 0.15);
}

.form-group select:disabled,
.form-group input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.form-group select option {
  background: #1e1b4b;
  color: #ffffff;
}

.ban-button {
  padding: 12px 24px;
  background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%);
  border: none;
  border-radius: 6px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.ban-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.4);
}

.ban-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.no-users {
  color: rgba(255, 255, 255, 0.5);
  font-style: italic;
  margin-top: 15px;
}

/* Banned Users List */
.banned-list-section {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(139, 92, 246, 0.3);
  border-radius: 8px;
  padding: 25px;
  margin-bottom: 30px;
}

.banned-list-section h2 {
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 600;
  color: #8b5cf6;
}

.no-banned {
  color: rgba(255, 255, 255, 0.5);
  font-style: italic;
}

.banned-users-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.banned-user-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(220, 38, 38, 0.3);
  border-radius: 6px;
  transition: all 0.2s;
}

.banned-user-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(220, 38, 38, 0.5);
}

.banned-user-info {
  flex: 1;
}

.banned-user-main {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.banned-username {
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
}

.banned-ip {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  background: rgba(0, 0, 0, 0.3);
  padding: 4px 8px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
}

.banned-user-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
}

.banned-date,
.banned-by,
.banned-reason {
  display: block;
}

.banned-reason {
  color: rgba(255, 255, 255, 0.8);
  font-style: italic;
}

.unban-button {
  padding: 10px 20px;
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  border: none;
  border-radius: 6px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.unban-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.4);
}

.unban-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Connected Users Section */
.connected-users-section {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(139, 92, 246, 0.3);
  border-radius: 8px;
  padding: 25px;
}

.connected-users-section h2 {
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 600;
  color: #8b5cf6;
}

.connected-users-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
}

.connected-user-card {
  padding: 14px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(139, 92, 246, 0.3);
  border-radius: 6px;
  transition: all 0.2s;
}

.connected-user-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(139, 92, 246, 0.5);
}

.user-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.user-name {
  font-weight: 600;
  font-size: 15px;
  color: #ffffff;
}

.user-ip {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  font-family: 'Courier New', monospace;
}

.user-status {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

/* Scrollbar styling */
.banned-users-panel::-webkit-scrollbar {
  width: 10px;
}

.banned-users-panel::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
}

.banned-users-panel::-webkit-scrollbar-thumb {
  background: rgba(139, 92, 246, 0.5);
  border-radius: 5px;
}

.banned-users-panel::-webkit-scrollbar-thumb:hover {
  background: rgba(139, 92, 246, 0.7);
}
`, "",{"version":3,"sources":["webpack://./src/components/BannedUsersPanel.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC,+BAA+B;;AAE/B;EACE,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,cAAc;EACd,gFAAgF;EAChF,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,wCAAwC;EACxC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,+BAA+B;AACjC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,yCAAyC;EACzC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":["/* src/components/BannedUsersPanel.css */\n/* Banned Users Panel styling */\n\n.banned-users-panel {\n  width: 100vw;\n  height: 100vh;\n  background: linear-gradient(135deg, #1e1b4b 0%, #312e81 100%);\n  color: #ffffff;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  overflow-y: auto;\n}\n\n.panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 30px;\n  border-bottom: 1px solid rgba(139, 92, 246, 0.3);\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.panel-header h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.refresh-button {\n  padding: 8px 16px;\n  background: rgba(139, 92, 246, 0.2);\n  border: 1px solid #8b5cf6;\n  border-radius: 6px;\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s;\n}\n\n.refresh-button:hover {\n  background: rgba(139, 92, 246, 0.3);\n  transform: translateY(-1px);\n}\n\n.panel-content {\n  padding: 30px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n/* Ban Section */\n.ban-section {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(139, 92, 246, 0.3);\n  border-radius: 8px;\n  padding: 25px;\n  margin-bottom: 30px;\n}\n\n.ban-section h2 {\n  margin: 0 0 20px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #8b5cf6;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.form-group select,\n.form-group input {\n  width: 100%;\n  padding: 10px 12px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(139, 92, 246, 0.3);\n  border-radius: 6px;\n  color: #ffffff;\n  font-size: 14px;\n  outline: none;\n  transition: all 0.2s;\n}\n\n.form-group select:focus,\n.form-group input:focus {\n  border-color: #8b5cf6;\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.form-group select:disabled,\n.form-group input:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.form-group select option {\n  background: #1e1b4b;\n  color: #ffffff;\n}\n\n.ban-button {\n  padding: 12px 24px;\n  background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%);\n  border: none;\n  border-radius: 6px;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.ban-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.4);\n}\n\n.ban-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.no-users {\n  color: rgba(255, 255, 255, 0.5);\n  font-style: italic;\n  margin-top: 15px;\n}\n\n/* Banned Users List */\n.banned-list-section {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(139, 92, 246, 0.3);\n  border-radius: 8px;\n  padding: 25px;\n  margin-bottom: 30px;\n}\n\n.banned-list-section h2 {\n  margin: 0 0 20px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #8b5cf6;\n}\n\n.no-banned {\n  color: rgba(255, 255, 255, 0.5);\n  font-style: italic;\n}\n\n.banned-users-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.banned-user-card {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(220, 38, 38, 0.3);\n  border-radius: 6px;\n  transition: all 0.2s;\n}\n\n.banned-user-card:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(220, 38, 38, 0.5);\n}\n\n.banned-user-info {\n  flex: 1;\n}\n\n.banned-user-main {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.banned-username {\n  font-weight: 600;\n  font-size: 16px;\n  color: #ffffff;\n}\n\n.banned-ip {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.7);\n  background: rgba(0, 0, 0, 0.3);\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-family: 'Courier New', monospace;\n}\n\n.banned-user-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.banned-date,\n.banned-by,\n.banned-reason {\n  display: block;\n}\n\n.banned-reason {\n  color: rgba(255, 255, 255, 0.8);\n  font-style: italic;\n}\n\n.unban-button {\n  padding: 10px 20px;\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  border: none;\n  border-radius: 6px;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.unban-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.4);\n}\n\n.unban-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Connected Users Section */\n.connected-users-section {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(139, 92, 246, 0.3);\n  border-radius: 8px;\n  padding: 25px;\n}\n\n.connected-users-section h2 {\n  margin: 0 0 20px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #8b5cf6;\n}\n\n.connected-users-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 12px;\n}\n\n.connected-user-card {\n  padding: 14px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(139, 92, 246, 0.3);\n  border-radius: 6px;\n  transition: all 0.2s;\n}\n\n.connected-user-card:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(139, 92, 246, 0.5);\n}\n\n.user-info {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.user-name {\n  font-weight: 600;\n  font-size: 15px;\n  color: #ffffff;\n}\n\n.user-ip {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.6);\n  font-family: 'Courier New', monospace;\n}\n\n.user-status {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n/* Scrollbar styling */\n.banned-users-panel::-webkit-scrollbar {\n  width: 10px;\n}\n\n.banned-users-panel::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.banned-users-panel::-webkit-scrollbar-thumb {\n  background: rgba(139, 92, 246, 0.5);\n  border-radius: 5px;\n}\n\n.banned-users-panel::-webkit-scrollbar-thumb:hover {\n  background: rgba(139, 92, 246, 0.7);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
